var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopDiGamma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1892_9702",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1892_9702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.8749L7.89998 19.3249C7.71665 19.4249 7.53748 19.4666 7.36248 19.4499C7.18748 19.4332 7.03331 19.3749 6.89998 19.2749C6.76665 19.1749 6.66665 19.0374 6.59998 18.8624C6.53331 18.6874 6.52498 18.5082 6.57498 18.3249L7.64998 13.7499L4.02498 10.6749C3.87498 10.5416 3.78331 10.3874 3.74998 10.2124C3.71665 10.0374 3.72498 9.86657 3.77498 9.6999C3.82498 9.53324 3.91665 9.39574 4.04998 9.2874C4.18331 9.17907 4.34998 9.11657 4.54998 9.0999L9.29998 8.6749L11.175 4.3249C11.2583 4.14157 11.375 4.00407 11.525 3.9124C11.675 3.82074 11.8333 3.7749 12 3.7749C12.1666 3.7749 12.325 3.82074 12.475 3.9124C12.625 4.00407 12.7416 4.14157 12.825 4.3249L14.7 8.6999L19.45 9.0999C19.65 9.11657 19.8166 9.18324 19.95 9.2999C20.0833 9.41657 20.175 9.55824 20.225 9.7249C20.275 9.89157 20.2791 10.0582 20.2375 10.2249C20.1958 10.3916 20.1 10.5416 19.95 10.6749L16.35 13.7499L17.425 18.3249C17.475 18.5082 17.4666 18.6874 17.4 18.8624C17.3333 19.0374 17.2333 19.1749 17.1 19.2749C16.9666 19.3749 16.8125 19.4332 16.6375 19.4499C16.4625 19.4666 16.2833 19.4249 16.1 19.3249L12 16.8749Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopDiGamma);
export default __webpack_public_path__ + "static/media/top_di_gamma.c3890961455bdf030ee68a0f0af11f0e.svg";
export { ForwardRef as ReactComponent };